import { Form, Formik, FormikProps } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import * as Yup from 'yup';
import CustomTabMenu from '../../../../component/CustomTabMenu';
import { KEY_DS_TAB_TIEP_DON, MESSAGE } from '../../../../utils/Constant';
import InfoPatientRight from '../../../components/InfoPatientRight';
import PhieuKhamChuyenKhoa from '../modal-nhap-vien/components/PhieuKhamChuyenKhoa';
import ThongTinChung from './components/ThongTinChung';

type Props = {
	open: boolean;
	onClose: () => void;
	onSave: (values: any) => void;
	itemEdit?: {
		treatmentDept: {
			code: string;
			name: string;
		};
		treatmentRoom: {
			code: string;
			name: string;
		};
	};
	patientInfo: any;
};

const ModalDieuTriNgoaiTru = ({ open, onClose, onSave, itemEdit, patientInfo }: Props) => {
	const formikRef = useRef<FormikProps<any>>(null);
	const [activeTab, setActiveTab] = useState('1');

	const validationSchema = Yup.object().shape({
		treatmentDept: Yup.object().nullable().required(MESSAGE.REQUIRED),
		treatmentRoom: Yup.object().nullable().required(MESSAGE.REQUIRED),
		medicalRecord: Yup.object().nullable().required(MESSAGE.REQUIRED),
	});

	const initialValues = {
		treatmentDept: null,
		treatmentRoom: null,
		treatmentReason: '',
		doctor: null,
		medicalRecord: null,
	};

	const onSubmit = (values: any) => {
		onSave({
			treatmentDeptCode: values?.treatmentDept?.code,
			treatmentDeptName: values?.treatmentDept?.name,
			treatmentDeptId: values?.treatmentDept?.id,

			treatmentRoomCode: values?.treatmentRoom?.code,
			treatmentRoomName: values?.treatmentRoom?.name,
			treatmentRoomId: values?.treatmentRoom?.id,

			treatmentDoctor: values?.doctor?.id ? String(values?.doctor?.id) : null,
			treatmentDoctorName: values?.doctor?.fullName || null,

			medicalRecordCode: values?.medicalRecord?.code,
			medicalRecordName: values?.medicalRecord?.name,
			
			treatmentReason: values?.treatmentReason || null,
			mauPhieuKhamBenh: values.template?.code,
			...(values?.template
				? {
						[values.template.code]: values?.form,
				  }
				: null),
		});
	};

	return (
		<Modal show={open} centered onHide={onClose} size="lg" scrollable>
			<ModalHeader closeButton>
				<Modal.Title>Điều trị ngoại trú</Modal.Title>
			</ModalHeader>

			<InfoPatientRight benhNhanInfo={patientInfo} />

			<Formik<any>
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				innerRef={formikRef}
			>
				{({ values }) => (
					<Form className="flex-column overflow-hidden">
						<ModalBody className="spaces min-h-300">
							<CustomTabMenu
								danhsachTabs={[
									{
										eventKey: '1',
										title: 'Thông tin chung',
										component: <ThongTinChung />,
									},
									...(values?.template
										? [
												{
													eventKey: '2',
													title: 'Phiếu khám chuyên khoa',
													component: <PhieuKhamChuyenKhoa />,
												},
										  ]
										: []),
								]}
								keyDanhSachTabs={KEY_DS_TAB_TIEP_DON}
								childrenTab
								activeTab={activeTab}
								onTabChange={(activeTab: any) => setActiveTab(activeTab)}
							/>
						</ModalBody>
						<ModalFooter>
							<Button className="btn-fill spaces px-16" type="submit">
								Lưu
							</Button>
						</ModalFooter>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default ModalDieuTriNgoaiTru;
